import React from "react";
import Loading from "react-fullscreen-loading";
import { useSelector } from "react-redux";

const LoadingComponent = () => {
  const { loading } = useSelector((state) => state.genericReducer);

  return <Loading loading={loading} background="rgba(0,0,0,0.6)" loaderColor="#3498db" style={{ zIndex: 99999999 }} />;
};

export default LoadingComponent;
